module.exports = __webpack_public_path__ + "img/23.0105e96e.png";